import type { StepContentConfig } from '../../utils';

export const signatureStepContent: StepContentConfig = {
    mainTitle: {
        site: 'Signature électronique',
        conseiller: 'Signature électronique de votre client',
        conseillermae: 'Signature électronique de votre adhérent',
    },
    signatureMethodLabel: {
        site: 'Moyen de signature',
        conseiller: 'Moyen de signature du client',
        conseillermae: "Moyen de signature de l'adhérent",
    },
    phoneLabel: {
        site: 'N° de téléphone (pour la signature)',
        conseiller: 'N° de téléphone du client (pour la signature)',
        conseillermae: "N° de téléphone de l'adhérent (pour la signature)",
    },
    phoneDescription: {
        site: 'Numéro où vous recevrez le code de signature',
        conseiller: 'Numéro où votre client recevra le code de signature',
        conseillermae: 'Numéro où votre adhérent recevra le code de signature',
    },
    emailLabel: {
        site: 'Adresse email (pour la signature)',
        conseiller: 'Adresse email du client (pour la signature)',
        conseillermae: "Adresse email de l'adhérent (pour la signature)",
    },
    emailDescription: {
        site: 'Email où vous recevrez le lien de signature',
        conseiller: 'Email où votre client recevra le lien de signature',
        conseillermae: 'Email où votre adhérent recevra le lien de signature',
    },
    buttonText: {
        site: 'Procéder à la signature',
        conseiller: 'Procéder à la signature du client',
        conseillermae: "Procéder à la signature de l'adhérent",
    },
    helpTitle: {
        site: "La signature électronique c'est quoi ?",
    },
    helpContent: {
        site: "La signature électronique est, pour un document numérique, l'équivalent de la signature manuscrite. En vertu du décret n°2001-272 du 30 mars 2001, elle a la même valeur légale qu'une signature manuscrite. Le client signe numériquement son contrat de manière totalement sécurisée et il est garanti par un tiers de confiance.",
    },
};
